import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'razonFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									auditar: true, 
									notaDelete: null, 
									tablaPost: ['datos_razon'],
									tablaDelete: []
								 }
							 }) 
						break;
						case 'inactivarFtn' :	
							await this.updateDataForm({state:'datos_razon/id_list_estado', data: 2})
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_all', 
									auditar: true, 
									notaDelete: null, 
									tablaPost: ['datos_razon'],
									tablaDelete: []
								 }
							 }) 
						break;

					}
				}
				await this.save(event.save)
				
				
				const await1 = this.getDataGet({ route: 'get_listrazones', data: 'usuarios'})
				const await2 = this.resetDataIndex()
				const await3 = this.resetGlobal({state: 'openModal'})
				const await4 = this.resetGlobal({state: 'saveConfig/capa'})
				const await5 = this.resetDataForm()
				await await1
				await await2
				await await3
				await await4
				await await5
			}
			catch{

			}			
		}		
	},
}
